<div class="source-destination-container">
  <div class="chiplist-destination">
    <div class="destination-header">
      <h3 class="header-title" *ngIf="tiers.length > 0">
        Into Price Tiers Over Here
      </h3>

      <button
        class="add-tier-button"
        kendoButton
        themeColor="primary"
        (click)="addTierDialogOpen = true"
      >
        <fa-icon class="icon-text" [icon]="['fas', 'plus']"></fa-icon>Create New
        Tier
      </button>
    </div>

    <h5 *ngIf="tiers.length == 0" class="thin-text justify-center subtle-text">
      Add the first tier to start assigning restaurants.
    </h5>
    <div class="destination-panel" *ngIf="tiers.length > 0">
      <kendo-expansionpanel
        *ngFor="let tier of tiers"
        (action)="toggleTier(tier.id)"
        [expanded]="tier.selected"
      >
        <ng-template kendoExpansionPanelTitleDirective>
          <div class="tier-header k-expander-title">
            <span class="tier-name">
              <kendo-label *ngIf="!tier.editing" (click)="toggleEdit(tier)">{{
                tier.name
              }}</kendo-label>
              <kendo-formhint *ngIf="tier.editing">
                Press Enter to save new name
              </kendo-formhint>

              <kendo-textbox
                class="tier-name-edit-input"
                *ngIf="tier.editing"
                (keyup.enter)="toggleEdit(tier)"
                [maxlength]="25"
                [(ngModel)]="tier.name"
              ></kendo-textbox>

              <kendo-label class="tier-restaurant-count"
                >({{
                  (tieredRestaurants | inTier: tier.id).length
                }})</kendo-label
              >
            </span>

            <div class="tier-icons">
              <span
                kendoTooltip
                *ngIf="tier.isLocked"
                position="top"
                class="content-align-center"
              >
                <fa-icon
                  title="This tier has pending changes, it cannot be modified"
                  class="lock-icon"
                  [icon]="['fas', 'lock']"
                ></fa-icon>
              </span>
              <button
                *ngIf="tier.isLocked"
                kendoButton
                size="small"
                fillMode="outline"
                themeColor="success"
                (click)="tierToUnlock = tier"
              >
                Unlock
              </button>

              <span
                kendoTooltip
                *ngIf="!tier.isLocked && !tier.isSynchedToKing"
                position="top"
                class="content-align-center"
              >
                <fa-icon
                  title="This tier is out of sync with its King restaurant"
                  class="error"
                  [icon]="['fas', 'rotate-exclamation']"
                ></fa-icon>
              </span>
              <span
                kendoTooltip
                [title]="tierAlignEnabled ? 'Click to align this tier' : 'This feature is disabled while we work on improving accuracy.'"
              >
                  <button
                    *ngIf="!tier.isLocked && !tier.isSynchedToKing"
                    kendoButton
                    [disabled]="tierAlignEnabled == false"
                    size="small"
                    fillMode="outline"
                    themeColor="success"
                    (click)="tierToSync = tier"
                  >
                    Sync Now
                  </button>
              </span>
            </div>
          </div>
        </ng-template>

        <div class="content">
          <kendo-chiplist
            *ngIf="(tieredRestaurants | inTier: tier.id).length > 0"
          >
            <kendo-chip
              fillMode="outline"
              (remove)="showUnassignRestaurantDialog(restaurant)"
              [removable]="!tier.isLocked"
              [removeSvgIcon]="removeIcon"
              *ngFor="let restaurant of tieredRestaurants | inTier: tier.id"
            >
              <span class="custom-content">
                <button
                  kendoButton
                  *ngIf="!restaurant.isVirtual"
                  [disabled]="tier.isLocked ?? false"
                  class="p-0"
                  fillMode="clear"
                  size="none"
                  themeColor="primary"
                  (click)="showSetKingDialog(restaurant)"
                >
                  <fa-icon
                    class="icon-text"
                    [ngClass]="
                      restaurant.isKing ? 'king-icon' : 'non-king-icon'
                    "
                    [icon]="[restaurant.isKing ? 'fas' : 'fal', 'crown']"
                  ></fa-icon>
                </button>

                <fa-icon
                  class="icon-text lab-icon"
                  *ngIf="restaurant.isVirtual"
                  [icon]="['fas', 'flask-gear']"
                ></fa-icon>

                <kendo-label class="restaurant-name-label">
                  {{ restaurant.name }}
                </kendo-label>
              </span>
            </kendo-chip>
          </kendo-chiplist>
          <h5
            class="thin-text justify-center subtle-text"
            *ngIf="(tieredRestaurants | inTier: tier.id).length == 0"
          >
            Start adding restaurants to this tier by selecting from the list on
            the right.
          </h5>
        </div>
        <div class="tier-footer">
          <button
            kendoButton
            class="m-t-4"
            themeColor="error"
            [disabled]="tier.isLocked ?? false"
            fillMode="solid"
            size="small"
            (click)="tierToRemove = tier"
          >
            <fa-icon class="icon-text" [icon]="['fas', 'trash']"></fa-icon
            >Delete
          </button>
        </div>
      </kendo-expansionpanel>
    </div>
  </div>

  <button
    kendoButton
    size="small"
    *ngIf="untieredRestaurants.length > 0"
    [disabled]="(untieredRestaurants | selected).length == 0"
    themeColor="primary"
    (click)="assignRestaurants()"
    class="source-to-target"
    fillMode="outline"
  >
    <fa-icon class="icon-text" [icon]="['fas', 'caret-left']"></fa-icon>Add
    Restaurant(s)
  </button>

  <div class="chiplist-source" *ngIf="tiers.length > 0">
    <div class="source-header">
      <h3>Move Unassigned Restaurants From Here</h3>
      <div class="autocomplete-container">
        <kendo-textbox
          [placeholder]="'Search by Restaurant No., DMA or City'"
          (valueChange)="handleFilter($event)"
        >
          <ng-template kendoPrefixTemplate>
            <button kendoButton fillMode="flat">
              <fa-icon [icon]="['fas', 'magnifying-glass']"></fa-icon>
            </button>
          </ng-template>
        </kendo-textbox>
      </div>
    </div>

    <kendo-chiplist selection="multiple" class="source-chiplist">
      <kendo-chip
        fillMode="outline"
        [disabled]="restaurant.parToken == null"
        [attr.aria-selected]="restaurant.selected"
        *ngFor="let restaurant of untieredRestaurants"
        (click)="toggleRestaurantSelect(restaurant)"
      >
        <span class="custom-content">
          <kendo-checkbox
            [disabled]="restaurant.parToken == null"
            [checkedState]="restaurant.selected"
          ></kendo-checkbox>
          <span
            kendoTooltip
            [title]="
              restaurant.parToken == null
                ? 'This restaurant does not have par connectivity'
                : ''
            "
            class="restaurant-name-label"
          >
            {{ restaurant.name }}
          </span>
        </span>
      </kendo-chip>
    </kendo-chiplist>

    <kendo-pager
      [total]="total"
      [pageSize]="pageSize"
      [pageSizeValues]="false"
      [skip]="state.skip ?? 0"
      (pageChange)="
        state.skip = $event.skip;
        state.take = $event.take;
        fetchUntieredRestaurants()
      "
    >
    </kendo-pager>
  </div>
</div>

<app-unassign-restaurant
  *ngIf="restaurantToRemove != null"
  [restaurant]="restaurantToRemove"
  (onConfirm)="unassignRestaurant($event)"
></app-unassign-restaurant>

<app-add-tier
  *ngIf="addTierDialogOpen"
  (onConfirm)="addTier($event)"
></app-add-tier>

<app-remove-tier
  [tierToRemove]="tierToRemove"
  *ngIf="tierToRemove != null"
  (onConfirm)="onRemovedTierConfirm($event)"
></app-remove-tier>

<app-set-king-restaurant
  *ngIf="restaurantToSetKing != null"
  [restaurantToSetKing]="restaurantToSetKing"
  (onConfirm)="onKingRestaurantSetConfirm($event)"
></app-set-king-restaurant>

<app-unlock-tier
  *ngIf="tierToUnlock != null"
  [tierToUnlock]="tierToUnlock"
  (onConfirm)="onUnlockTierConfirm($event)"
></app-unlock-tier>

<app-align-tier
  *ngIf="tierToSync != null"
  [tierToAlign]="tierToSync"
  (onConfirm)="onSyncTierConfirm($event)"
></app-align-tier>
